import { render } from "./winner-badge.vue?vue&type=template&id=ca81ede4&scoped=true"
import script from "./winner-badge.vue?vue&type=script&lang=js"
export * from "./winner-badge.vue?vue&type=script&lang=js"

import "./winner-badge.vue?vue&type=style&index=0&id=ca81ede4&scoped=true&lang=css"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca81ede4"]])

export default __exports__